import axios from 'axios';
import { GETTABLEGALLERY } from '../index';

export const tableBookGalleryApi = (formData) => {
  return axios.post(GETTABLEGALLERY, formData);
};